import { createEnum } from './enumTools';

// UNTIL AUTOMATIC TASK WILL BE DONE, MAKE SURE TO SYNC WITH DB
// NOTE: MAKE SURE TO CHANGE smartAgent.js as well, UNTIL USING BABEL OR OTHER LIBRARAY TO REQUIRE EXPORT
export default createEnum([
    'ללא סוכן חכם',
    'יומי - כל בוקר',
    'שבועי - ראשון בבוקר',
    'מיידי - מספר פעמים ביום',
]);

export const SMART_AGENT_NOTIFICATION_TYPE = createEnum([
    'NONE',
    'CANDIDATE_DAILY',
    'CANDIDATE_WEEKLY',
    'CANDIDATE_IMMEDIATELY',
]);
